import { render, staticRenderFns } from "./CorrigirPrimeiro.vue?vue&type=template&id=7cf031d5&scoped=true&"
import script from "./CorrigirPrimeiro.vue?vue&type=script&lang=js&"
export * from "./CorrigirPrimeiro.vue?vue&type=script&lang=js&"
import style0 from "./CorrigirPrimeiro.vue?vue&type=style&index=0&id=7cf031d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf031d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRadio,VRadioGroup,VRow})
